import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=7d075b81&scoped=true&xmlns%3ATabPane=http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink&"
import script from "./Customer.vue?vue&type=script&lang=js&"
export * from "./Customer.vue?vue&type=script&lang=js&"
import style0 from "./Customer.vue?vue&type=style&index=0&id=7d075b81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d075b81",
  null
  
)

export default component.exports